import InstitutionDetailsLayout from '@/features/institution/layouts/details';
import InstitutionOwnershipForm from '@/features/institution/ownership/components/form';
import { INSTITUTION_DETAILS_TYPE } from '@/features/institution/utils';

const InstitutionOnboardingOwnershipPage = () => {
  return (
    <InstitutionDetailsLayout detailsKey="ownership" detailsType={INSTITUTION_DETAILS_TYPE.ONBOARDING}>
      <InstitutionOwnershipForm />
    </InstitutionDetailsLayout>
  );
};
InstitutionOnboardingOwnershipPage.displayName = 'InstitutionOnboardingOwnershipPage';

export default InstitutionOnboardingOwnershipPage;
